export default __webpack_public_path__ + "static/media/krolowa.d6e0a708.svg";